import api from './api'

/** One result row — every group shares this shape so the dropdown renders uniformly. */
export interface SearchHit {
  id: string
  title: string
  subtitle?: string
  detail?: string
  route: string
  /** Broker rows carry contact detail so the answer is in the dropdown itself. */
  firm?: string
  email?: string
  phone?: string
  office?: string
  /** Field hits: the catalogue field, and the deal holding it (if any) with the
   *  dossier page that field is read on. */
  fieldKey?: string
  loanId?: string
  dossierTab?: string
}

export interface SearchResults {
  query: string
  loans: SearchHit[]
  /** Catalogue fields a plain-English query names ('cap rate', 'loan to value'). */
  fields?: SearchHit[]
  intake: SearchHit[]
  brokers: SearchHit[]
  legalMatters: SearchHit[]
  auditFindings: SearchHit[]
  total: number
}

export const searchService = {
  /** Search every record the platform holds: loans, intake, brokers, legal
   * matters, audit findings. */
  global: (q: string, signal?: AbortSignal) =>
    api
      .get('/search', { params: { q }, signal })
      .then((r) => r.data as SearchResults),
}
